// CA-16 Natulim DB 13/07/2026 — Copiado de PT (CA-14, origen PL): motor Build-a-Box reutilizado en FR sin app JUO (datos desde settings del editor, selling plans nativos / Stay AI).
function dispatchUpdate() {
  document.dispatchEvent(
    new CustomEvent("juo-box:updated:state", {
      detail:
        window.juoBoxCart && window.juoBoxCart.getSubtotal
          ? window.juoBoxCart.getSubtotal()
          : { subtotal: 0, compareToPrice: 0, savings: 0 },
    })
  );
}

function normalizeSellingPlanIdString(value) {
  if (value == null || value === "") {
    return "";
  }
  const raw = String(value).trim();
  if (raw.includes("gid://")) {
    const m = raw.match(/(\d+)\s*$/);
    return m ? m[1] : "";
  }
  return /^\d+$/.test(raw) ? raw : "";
}

function sellingPlanIdFromAllocation(allocation) {
  if (!allocation) {
    return null;
  }
  let id = allocation.selling_plan_id;
  if (id == null && allocation.selling_plan && typeof allocation.selling_plan === "object") {
    id = allocation.selling_plan.id;
  }
  const normalized = normalizeSellingPlanIdString(id);
  return normalized === "" ? null : normalized;
}

function allocationPlanNameFromAllocation(allocation) {
  const sp = allocation && allocation.selling_plan;
  if (sp && typeof sp === "object" && sp.name != null) {
    return String(sp.name);
  }
  if (allocation && allocation.name != null) {
    return String(allocation.name);
  }
  return "";
}

function normalizePlanNameForMatch(name) {
  return String(name || "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, " ");
}

function allocationPlanNameNormalized(allocation) {
  return normalizePlanNameForMatch(allocationPlanNameFromAllocation(allocation));
}

function getSelectedSellingPlanLabelFromWidget() {
  if (typeof document === "undefined") {
    return "";
  }
  const sel = document.querySelector(
    '#juo-subscription-widget [data-ref="selling-plan"]'
  );
  if (!sel || !sel.selectedOptions || !sel.selectedOptions.length) {
    return "";
  }
  const opt = sel.selectedOptions[0];
  const fromData = opt.dataset && opt.dataset.planLabel;
  if (fromData && String(fromData).trim()) {
    return String(fromData).trim();
  }
  return (opt.textContent || "").trim();
}

function buildSelectOptionsFromPlansList(plans) {
  const uniqueByKey = new Map();
  (plans || []).forEach((plan) => {
    if (!plan || plan.id == null) {
      return;
    }
    const trimmedName = String(plan.name || "").trim();
    if (!trimmedName) {
      return;
    }
    const idStr = normalizeSellingPlanIdString(plan.id);
    if (!idStr) {
      return;
    }
    const { discountValue, discountType } =
      extractSellingPlanDiscountFields(plan);
    const planKey = `${trimmedName}__${discountType || "none"}__${discountValue ?? "none"}`;
    if (!uniqueByKey.has(planKey)) {
      uniqueByKey.set(planKey, {
        id: idStr,
        name: trimmedName,
        discountValue,
        discountType,
      });
    }
  });
  return Array.from(uniqueByKey.values());
}

function createProducts(boxData) {
  const mergedByVariantId = new Map(
    (boxData.variants || []).map((v) => [String(v.id), v])
  );
  const productsById = new Map(
    (boxData.products || []).map((p) => [String(p.id), p])
  );

  const products = (boxData.variants || []).map((variant) => {
    const merged = mergedByVariantId.get(String(variant.id));
    const rawSpa =
      merged && Array.isArray(merged.selling_plan_allocations)
        ? merged.selling_plan_allocations
        : variant.selling_plan_allocations;
    const sellingPlanAllocations = Array.isArray(rawSpa) ? rawSpa : [];
    const productIdRaw =
      variant.product_id != null ? String(variant.product_id) : "";
    const parent = productIdRaw ? productsById.get(productIdRaw) : null;
    const firstMedia =
      parent && parent.media
        ? Array.isArray(parent.media)
          ? parent.media[0]
          : parent.media.at && parent.media.at(0)
        : null;
    const imageURL =
      firstMedia && firstMedia.preview_image && firstMedia.preview_image.src
        ? firstMedia.preview_image.src
        : "";
    return {
      productId: productIdRaw || (parent != null ? String(parent.id) : ""),
      variantId: String(variant.id),
      imageURL,
      title: parent != null ? parent.title : "",
      variantTitle: variant.title != null ? variant.title : "",
      price: variant.price,
      sellingPlanAllocations,
    };
  });
  function addProduct(product) {
    products.push(product);
  }
  return {
    data: products,
    addProduct,
  };
}

function moneyFieldToCents(raw) {
  if (raw == null || raw === "") {
    return 0;
  }
  const s = String(raw).trim().replace(",", ".");
  const n = Number.parseFloat(s);
  if (!Number.isFinite(n)) {
    return 0;
  }
  const hasDecimalInString = /\d\.\d/.test(s);
  const isNonIntegerNumber = typeof raw === "number" && !Number.isInteger(n);
  if (hasDecimalInString || isNonIntegerNumber) {
    return Math.round(n * 100);
  }
  return Math.round(n);
}

function tierMinimumProductsCount(tier) {
  if (tier == null) {
    return 0;
  }
  const candidates = [
    tier.productsCount,
    tier.minimumProductsCount,
    tier.minProductsCount,
    tier.minimum_products_count,
    tier.count,
    tier.minimum,
    tier.minCount,
    tier.minItems,
    tier.items,
    tier.quantity,
    tier.minQty,
    tier.from,
  ];
  for (const raw of candidates) {
    if (raw != null) {
      const n = Number(raw);
      if (Number.isFinite(n) && n > 0) return n;
    }
  }
  return 0;
}

function isCartTotalThreshold(boxData) {
  const raw = boxData && boxData.tiersThresholdType != null ? String(boxData.tiersThresholdType) : '';
  const t = raw.toLowerCase().replace(/[^a-z0-9]/g, '_');
  return t.includes('cart_total') || t.includes('minimum_cart') || t.includes('subtotal') || t.includes('cart_value');
}

function tierCartTotalThreshold(tier) {
  if (tier == null) return 0;
  const raw = tier.threshold != null ? tier.threshold
    : tier.minimumCartTotal != null ? tier.minimumCartTotal
    : tier.minimumSubtotal != null ? tier.minimumSubtotal
    : 0;
  const n = Number(raw);
  return Number.isFinite(n) && n > 0 ? n : 0;
}

function tierGetThreshold(tier, boxData) {
  return isCartTotalThreshold(boxData) ? tierCartTotalThreshold(tier) : tierMinimumProductsCount(tier);
}

function tierMeaningfulQuantity(boxData, state, qtyByVariant) {
  const raw =
    boxData && boxData.tiersThresholdType != null
      ? String(boxData.tiersThresholdType)
      : "";
  const type = raw.toLowerCase().replace(/\s+/g, "_");
  if (
    type.includes("distinct") ||
    type.includes("unique") ||
    type.includes("different_flavor") ||
    type.includes("different_flavour") ||
    type.includes("differentflavor")
  ) {
    return Object.keys(qtyByVariant).length;
  }
  return state.products.length;
}

function parseTierPercentFromTier(tier) {
  if (tier == null) {
    return 0;
  }
  const raw =
    tier.value != null
      ? tier.value
      : tier.discount != null
        ? tier.discount
        : tier.discountPercent != null
          ? tier.discountPercent
          : 0;
  if (raw === "" || raw == null) {
    return 0;
  }
  const n = Number.parseFloat(String(raw).replace(/%/g, "").replace(",", ".").trim());
  if (!Number.isFinite(n) || n <= 0) {
    return 0;
  }
  return n;
}

function getParentProductQuantityMultiplier() {
  const productForm = document.querySelector(
    "form.product-form, form.product-single__form, form[data-type='add-to-cart-form']"
  );
  const formId = productForm ? productForm.getAttribute("id") : null;
  const qtyInput =
    (productForm ? productForm.querySelector('input[name="quantity"]') : null) ||
    (formId
      ? document.querySelector(`input[name="quantity"][form="${formId}"]`)
      : null) ||
    document.querySelector('input[name="quantity"][data-quantity-input]');
  const baseQty = qtyInput ? Number.parseInt(qtyInput.value || "1", 10) : 1;
  return Number.isFinite(baseQty) && baseQty > 0 ? baseQty : 1;
}

function createBoxCart(boxData, allProducts, tiers, sellingPlans) {
  const BOX_CART_STATE_KEY = "juo-box-products";
  const state = {
    products: [],
    cartLinesToAdd:  new Map(),
    cartLinesToRemove: [],
    parentProduct: null,
  };
  class CartError extends Error {}
  function init() {
    state.parentProduct = boxData.product;
    loadState();
  }
  function saveState() {
    if (localStorage != null) {
      localStorage.setItem(BOX_CART_STATE_KEY, JSON.stringify(state.products));
    }
  }
  function loadState() {
    if (window.Shopify == null) {
      return;
    }
    fetch(window.Shopify.routes.root + "cart.json", { cache: "no-store" })
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else {
          return null;
        }
      })
      .then((cart) => {
        const items = [];
        if (cart != null) {
          cart.items.forEach((item) => {
            if ("_parent_product_id" in item.properties) {
              items.push({
                variantId: String(item.variant_id),
                quantity: item.quantity,
                imageURL: item.featured_image.url,
              });
            }
            state.cartLinesToRemove.push(item);
          });
        }
        if (items.length === 0 && localStorage != null) {
          const boxState = localStorage.getItem(BOX_CART_STATE_KEY);
          if (boxState != null) {
            items.push(
              ...JSON.parse(boxState).map((item) => ({
                ...item,
                quantity: 1,
              }))
            );
          }
        }
        items.map((item) => {
          for (let i = 0; i < item.quantity; i++) {
            state.products.push({ ...item, quantity: 1 });
          }
        });
        updateCartLinesToAdd();
        document.dispatchEvent(
          new CustomEvent("juo-box:updated:state", {
            detail: getSubtotal(),
          })
        );
      });
  }
  function clearState() {
    if (localStorage != null) {
      localStorage.removeItem(BOX_CART_STATE_KEY);
    }
    state.products = [];
    updateCartLinesToAdd();
  }
  function getProductSellingPlan(
    product,
    sellingPlanId,
    boxData,
    selectedPlanLabel
  ) {
    const allocs = Array.isArray(product && product.sellingPlanAllocations)
      ? product.sellingPlanAllocations
      : [];
    if (!product || allocs.length === 0) {
      return null;
    }

    const labelNorm = selectedPlanLabel
      ? normalizePlanNameForMatch(selectedPlanLabel)
      : "";
    if (labelNorm) {
      const byLabel = allocs.find(
        (a) => allocationPlanNameNormalized(a) === labelNorm
      );
      if (byLabel) {
        return byLabel;
      }
    }

    const want = normalizeSellingPlanIdString(sellingPlanId);
    let allocation = want
      ? allocs.find((a) => sellingPlanIdFromAllocation(a) === want)
      : null;

    if (!allocation && boxData && boxData.sellingPlans && sellingPlanId != null) {
      const selectedBoxPlan = boxData.sellingPlans.find(
        (p) => String(p.id) === String(sellingPlanId)
      );
      if (selectedBoxPlan && selectedBoxPlan.name) {
        const targetName = normalizePlanNameForMatch(selectedBoxPlan.name);
        allocation = allocs.find(
          (a) => allocationPlanNameNormalized(a) === targetName
        );
      }
    }

    return allocation || null;
  }

  function resolveProductSellingPlan(
    product,
    primaryPlanId,
    boxData,
    selectedPlanLabel
  ) {
    if (product == null) {
      return null;
    }
    const allocs = Array.isArray(product.sellingPlanAllocations)
      ? product.sellingPlanAllocations
      : [];
    if (allocs.length === 0) {
      return null;
    }
    if (primaryPlanId != null || selectedPlanLabel) {
      const fromPrimary = getProductSellingPlan(
        product,
        primaryPlanId,
        boxData,
        selectedPlanLabel
      );
      if (fromPrimary) {
        return fromPrimary;
      }
    }
    const fallbackId =
      boxData && boxData.parentProductDefaultSellingPlanId != null
        ? boxData.parentProductDefaultSellingPlanId
        : null;
    if (
      !selectedPlanLabel &&
      fallbackId != null &&
      String(fallbackId) !== String(primaryPlanId)
    ) {
      const fromParent = getProductSellingPlan(
        product,
        fallbackId,
        boxData,
        ""
      );
      if (fromParent) {
        return fromParent;
      }
    }
    if (!selectedPlanLabel) {
      return allocs[0];
    }
    return null;
  }

  function getSubtotal(options = {}) {
    let totalPrice = 0;
    let compareToPrice = 0;
    const selectedPlanId =
      typeof sellingPlans.getSelectedPlanId === "function"
        ? sellingPlans.getSelectedPlanId()
        : null;
    const forcedPlanId =
      options.forceSellingPlanId != null ? options.forceSellingPlanId : null;
    const sellingPlanId =
      forcedPlanId != null ? forcedPlanId : sellingPlans.sellingPlan();
    const modeSub =
      typeof document !== "undefined" &&
      document.querySelector(
        '#juo-subscription-widget input[name="mode"]:checked'
      )?.value === "subscription";
    const isSubscribed =
      options.forceSubscribed != null
        ? options.forceSubscribed
        : Boolean(sellingPlanId) || modeSub;
    const primaryForSubtotal =
      isSubscribed && (sellingPlanId || selectedPlanId)
        ? sellingPlanId || selectedPlanId
        : null;
    const selectedPlanLabelForCart = getSelectedSellingPlanLabelFromWidget();
    const freeProductsCents =
      boxData.freeProduct.price != null &&
      isSubscribed &&
      state.products.length >= boxData.freeProductFrom
        ? moneyFieldToCents(boxData.freeProduct.price)
        : 0;
    const qtyByVariant = {};
    state.products.forEach((boxProduct) => {
      const id = String(boxProduct.variantId);
      qtyByVariant[id] = (qtyByVariant[id] || 0) + 1;
    });

    const isCartTotal = isCartTotalThreshold(boxData);
    let otpSumForTierEur = 0;
    if (isCartTotal) {
      Object.keys(qtyByVariant).forEach((variantId) => {
        const qty = qtyByVariant[variantId];
        const product = allProducts.find(({ variantId: vid }) => String(vid) === String(variantId));
        if (product != null) {
          otpSumForTierEur += moneyFieldToCents(product.price) * qty / 100;
        }
      });
    }
    const tierQty = isCartTotal ? otpSumForTierEur : tierMeaningfulQuantity(boxData, state, qtyByVariant);
    const tierValue = tiers.getEffectiveTierDiscountPercent(tierQty);
    const discountType = (boxData.boxDiscountType || "").toUpperCase();
    const isFixedTier = discountType === "FIXED_AMOUNT";
    const isPriceTier = discountType === "PRICE";

    Object.keys(qtyByVariant).forEach((variantId) => {
      const qty = qtyByVariant[variantId];
      const product = allProducts.find(
        ({ variantId: vid }) => String(vid) === String(variantId)
      );
      if (product == null) {
        return;
      }
      const productSellingPlan = isSubscribed
        ? resolveProductSellingPlan(
            product,
            primaryForSubtotal,
            boxData,
            selectedPlanLabelForCart
          )
        : null;
      const productPrice = moneyFieldToCents(
        productSellingPlan != null ? productSellingPlan.price : product.price
      );
      const baseCents = moneyFieldToCents(product.price);

      for (let i = 0; i < qty; i++) {

        const discountCents = (isFixedTier || isPriceTier) ? 0 : Math.floor(productPrice * tierValue / 100);
        totalPrice += productPrice - discountCents;
      }
      compareToPrice += Math.round(baseCents * qty);
    });

    if (isPriceTier && tierValue > 0) {
      totalPrice = tierValue * 100;
    }

    if (isFixedTier && tierValue > 0) {
      totalPrice = Math.max(0, totalPrice - tierValue * 100);
    }

    compareToPrice += freeProductsCents;
    const subtotalRounded = Math.round(totalPrice);
    const compareToPriceRounded = Math.round(compareToPrice);

    return {
      subtotal: subtotalRounded,
      compareToPrice: compareToPriceRounded,
      savings: compareToPriceRounded - subtotalRounded,
    };
  }
  function getBoxItemsFromInputs() {
    const items = [];
    const inputs = document.querySelectorAll(
      '.box-builder__products-list input.product-qty-input'
    );
    inputs.forEach((input) => {
      const qty = Number.parseInt(input.value || "0", 10);
      const variantId = input.dataset.variant || "";
      if (!variantId || qty <= 0) return;
      items.push({ variantId, quantity: qty });
    });
    return items;
  }

  async function addToCart() {
    if (window.Shopify == null) {
      return;
    }
    const { parentProduct } = state;
    const subtotal = getSubtotal();
    const { freeProduct } = boxData;
    const sellingPlanInput = document.querySelector(
      'form.product-form input[name="selling_plan"], form.product-single__form input[name="selling_plan"], form[data-type="add-to-cart-form"] input[name="selling_plan"]'
    );
    const widgetPlanSelect = document.querySelector(
      '#juo-subscription-widget [data-ref="selling-plan"]'
    );
    const modeSubscription =
      document.querySelector(
        '#juo-subscription-widget input[name="mode"]:checked'
      )?.value === "subscription";
    const sellingPlanIdFromWidget =
      modeSubscription && widgetPlanSelect && widgetPlanSelect.value
        ? widgetPlanSelect.value
        : null;
    const sellingPlanId =
      sellingPlanIdFromWidget ||
      (sellingPlanInput && sellingPlanInput.value
        ? sellingPlanInput.value
        : null);
    const primaryPlanForCart =
      sellingPlanId ||
      (modeSubscription && boxData.parentProductDefaultSellingPlanId != null
        ? String(boxData.parentProductDefaultSellingPlanId)
        : null);
    const selectedPlanLabelForCart = getSelectedSellingPlanLabelFromWidget();
    const cartItems = getBoxItemsFromInputs().flatMap(({ variantId, quantity }) => {
      const product = allProducts.find(
        ({ variantId: id }) => String(id) === String(variantId)
      );
      const productSellingPlan =
        modeSubscription && product != null
          ? resolveProductSellingPlan(
              product,
              primaryPlanForCart || null,
              boxData,
              selectedPlanLabelForCart
            )
          : null;

      if (modeSubscription && product != null && !productSellingPlan) {
        throw new CartError(
          "L'abonnement sélectionné est introuvable pour l'un des produits du coffret (vérifiez les plans communs)."
        );
      }

      const productSellingPlanId = sellingPlanIdFromAllocation(productSellingPlan);

      const item = {
        id: parseInt(variantId, 10),
        quantity,
        properties: {
          _box: `box-${parentProduct == null ? void 0 : parentProduct.id}`,
          _parent_product_handle: `${
            parentProduct == null ? void 0 : parentProduct.handle
          }`,
          _parent_product_id: `${
            parentProduct == null ? void 0 : parentProduct.id
          }`,
        },
        ...(productSellingPlanId != null
          ? { selling_plan: productSellingPlanId }
          : {}),
      };
      return [item];
    });
    /* CA-16 Natulim DB 13/07/2026 — FR: el regalo se añade también en modo compra única
       (en PL/PT lo cobraba la app JUO; en FR el precio 0 lo aplica un descuento automático
       Buy X Get Y en el admin de Shopify). Se exige freeProductFrom > 0 para poder
       desactivar el regalo desde el editor. */
    const freeToCart =
      boxData.freeProductFrom > 0 &&
      cartItems.reduce((sum, item) => sum + (item.quantity || 0), 0) >=
        boxData.freeProductFrom &&
      freeProduct.id != null
        ? [
            {
              id: freeProduct.id,
              quantity: 1,
              properties: {
                _box: `box-${parentProduct.id}`,
                _parent_product_handle: `${parentProduct.handle}`,
              },
            },
          ]
        : [];
    const cartDrawer = document.querySelector("cart-drawer");
    const cart = document.querySelector("cart-page");
    const popup = document.querySelector("#CartNotificationPopup");
    const cartSectionId =
      (cartDrawer && cartDrawer.dataset.sectionId) ||
      (cart && cart.dataset.sectionId) ||
      "cart-notification-popup-content";

    const allItems = [...cartItems, ...freeToCart];
    const root =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
      "/";
    const addUrl = `${root}cart/add.js`;
    const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
    let attempt = 0;
    let responseData = null;
    while (attempt < 3) {
      const response = await fetch(addUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
          Accept: "application/json",
        },
        body: JSON.stringify({
          attributes: {
            [`_box-${parentProduct == null ? void 0 : parentProduct.id}-savings`]:
              subtotal.savings,
          },
          items: allItems,
          sections: cartDrawer && typeof cartDrawer.getSectionsToRender === "function"
            ? cartDrawer.getSectionsToRender().map((s) => s.id)
            : [],
          sections_url: window.location.pathname,
        }),
      });
      const responseText = await response.text();
      try {
        responseData = JSON.parse(responseText);
      } catch {

      }
      if (response.status === 429) {
        const waitMs = attempt === 0 ? 800 : 1600;
        await sleep(waitMs);
        attempt += 1;
        continue;
      }
      if (response.status !== 200) {
        if (responseData && "description" in responseData) {
          throw new CartError(responseData.description);
        }
        throw new Error("Unexpected response status: " + response.status);
      }
      if (responseData && responseData.errors) {
        throw new Error(responseData.errors);
      }
      break;
    }
    clearState();
    document.dispatchEvent(new CustomEvent("juo-box:cart:added"));

    if (window.juoReloadCart) {
      const parsedState = responseData && responseData.id
        ? responseData
        : { id: cartItems[0] ? cartItems[0].id : null, quantity: 1 };
      window.juoReloadCart(parsedState);
    }
    document.dispatchEvent(new Event("reload-side-cart"));

    setTimeout(() => {
      const cartDrawerEl = document.getElementById("CartDrawer");
      const isDrawerOpen =
        cartDrawerEl &&
        (cartDrawerEl.classList.contains("is-opened") ||
          cartDrawerEl.hasAttribute("open"));
      if (isDrawerOpen) {
        return;
      }
      const cartButton = document.querySelector(
        'button[data-sidebar-button][data-sidebar-id="CartDrawer"]'
      );
      if (cartButton) {
        cartButton.click();
      }
    }, 250);

    return responseData;
  }

  function dispatchBoxUpdatedEvent() {
    document.dispatchEvent(
      new CustomEvent("juo-box:updated:state", {
        detail: getSubtotal(),
      })
    );
  }

  function updateCartLinesToAdd() {
    const { products, cartLinesToAdd } = state;
    cartLinesToAdd.clear();
    products.map(({ variantId }) => {
      const currentItem = cartLinesToAdd.get(variantId);
      if (currentItem != null) {
        cartLinesToAdd.set(variantId, {
          ...currentItem,
          quantity: products.filter((product) => product.variantId === variantId)
            .length,
        });
        return;
      }
      cartLinesToAdd.set(variantId, {
        variantId,
        quantity: products.filter((product) => product.variantId === variantId)
          .length,
      });
    });
  }
  function totalQtyForVariant(variantId) {
    var _a;
    return (_a = state.cartLinesToAdd.get(variantId)) == null
      ? void 0
      : _a.quantity;
  }
  init();
  return {
    addProduct(variantId) {
      const product = allProducts.find(
        (product2) => product2.variantId === variantId
      );
      if (product == null) {
        return;
      }
      state.products.push({
        variantId: product.variantId,
        imageURL: product.imageURL,
        quantity: 1,
      });
      updateCartLinesToAdd();
      saveState();
      dispatchBoxUpdatedEvent();
    },
    removeProduct(variantId) {
      let lastIndex = state.products.length - 1;
      for (let i = lastIndex; i >= 0; i--) {
        if (state.products[i].variantId === variantId) {
          lastIndex = i;
        }
      }
      state.products.splice(lastIndex, 1);
      updateCartLinesToAdd();
      saveState();
      dispatchBoxUpdatedEvent();
    },
    products() {
      return state.products;
    },
    totalQtyForVariant,
    addToCart,
    dispatchBoxUpdatedEvent,
    getSubtotal: getSubtotal,
    clearState,
  };
}
function createBoxData() {
  const dataElement = document.getElementById("juo-box-data");
  if (dataElement == null) {
    return;
  }
  const data = (function () {
    const parsed = JSON.parse(dataElement.innerText);
    const prices = {};
    const idList = Array.isArray(parsed.ids) ? parsed.ids : [];
    idList.forEach((variantId) => {
      const foundVariant = parsed.variants.find(
        (variant) => variant.id == variantId
      );
      if (foundVariant != null) {
        prices[variantId] = foundVariant.price;
      }
    });
    const allSellingPlans = parsed.allSellingPlans
      .flatMap((group) => {
        if (Array.isArray(group)) {
          return group.flatMap((plan) => (Array.isArray(plan) ? plan : [plan]));
        }
        return [];
      })
      .filter((v, i, a) => a.findIndex((v2) => v2.id === v.id) === i);
    const variants = parsed.variants.map((variant) => {
      const spa = Array.isArray(variant.selling_plan_allocations)
        ? variant.selling_plan_allocations
        : [];
      return {
        ...variant,
        selling_plan_allocations: spa.map((allocation) => {
          const sid = sellingPlanIdFromAllocation(allocation);
          const foundSellingPlan = allSellingPlans.find(
            (plan) => sid && normalizeSellingPlanIdString(plan.id) === sid
          );
          return {
            ...allocation,
            name: foundSellingPlan != null ? foundSellingPlan.name : "",
          };
        }),
      };
    });
    const rawBoxPlanIds = parsed.rawBoxSellingPlanIds;
    let rawBoxSellingPlanIds = [];
    if (rawBoxPlanIds != null) {
      if (typeof rawBoxPlanIds === "string" && rawBoxPlanIds.trim()) {
        rawBoxSellingPlanIds = rawBoxPlanIds
          .split(",")
          .map((s) => normalizeSellingPlanIdString(s.trim()))
          .filter(Boolean);
      } else if (Array.isArray(rawBoxPlanIds)) {
        rawBoxSellingPlanIds = rawBoxPlanIds
          .map((id) => normalizeSellingPlanIdString(String(id)))
          .filter(Boolean);
      }
    }
    const boxDiscountType =
      typeof parsed.boxDiscountType === "string" && parsed.boxDiscountType.trim()
        ? parsed.boxDiscountType.trim().toUpperCase()
        : "PERCENTAGE";
    return {
      ids: Array.isArray(parsed.ids) ? parsed.ids : [],
      tiers: parsed.tiers,
      sellingPlans: parsed.sellingPlans,
      allSellingPlans,
      rawBoxSellingPlanIds,
      boxDiscountType,
      product: parsed.product,
      freeProduct: parsed.freeProduct,
      products: parsed.products,
      variants,
      minItemsCount: parsed.minItemsCount,
      freeProductFrom: parsed.freeProductFrom,
      parentProductDefaultSellingPlanId:
        parsed.parentProductDefaultSellingPlanId != null
          ? parsed.parentProductDefaultSellingPlanId
          : null,
      dedicatedSellingPlanGroupId:
        parsed.dedicatedSellingPlanGroupId != null &&
        String(parsed.dedicatedSellingPlanGroupId).trim() !== ""
          ? String(parsed.dedicatedSellingPlanGroupId).trim()
          : null,
      tiersThresholdType:
        parsed.tiersThresholdType != null ? parsed.tiersThresholdType : null,
      prices,
      boxSubtitle:
        parsed.boxSubtitle != null && String(parsed.boxSubtitle).trim() !== ""
          ? String(parsed.boxSubtitle).trim()
          : "",
      babThemeSubtitleFallback:
        parsed.babThemeSubtitleFallback != null
          ? String(parsed.babThemeSubtitleFallback)
          : "",
    };
  })();
  return {
    data,
  };
}
function createTiers(tiers, boxData) {
  const getTh = (t) => tierGetThreshold(t, boxData);
  const sorted = [...(tiers || [])].sort((a, b) => getTh(a) - getTh(b));
  const lastTier = () => {
    const [last] = sorted.slice(-1) ?? [];
    return last;
  };
  const tierIndex = (quantity) => {
    const last = lastTier();
    if (last && getTh(last) > 0 && quantity >= getTh(last)) {
      return sorted.length - 1;
    }
    return sorted.findIndex((tier2) => getTh(tier2) > quantity) - 1;
  };
  const tier = (quantity) => {
    return tierIndex(quantity) >= 0 ? sorted[tierIndex(quantity)] : null;
  };
  const nextTier = (quantity) => sorted[tierIndex(quantity) + 1];
  const hasLastTier = (quantity) => {
    const [last] = sorted.slice(-1) ?? [];
    if (last) {
      const q =
        quantity != null && typeof quantity === "object" && quantity.value != null
          ? Number(quantity.value)
          : Number(quantity);
      return getTh(last) <= (Number.isFinite(q) ? q : 0);
    }
    return false;
  };
  const tiersMaxProducts = (tiers || []).reduce(function (max, tier2) {
    return Math.max(max, getTh(tier2));
  }, 0);
  const countToNextTier = (quantity) => {
    const nt = nextTier(quantity);
    if (nt) {
      return getTh(nt) - quantity;
    }
    return null;
  };

  const getEffectiveTierDiscountPercent = (quantity) => {
    const q = Number(quantity) || 0;
    if (q <= 0 || sorted.length === 0) {
      return 0;
    }
    let best = 0;
    for (let i = 0; i < sorted.length; i++) {
      const tier2 = sorted[i];
      const minCount = getTh(tier2);
      if (minCount > 0 && q >= minCount) {
        const p = parseTierPercentFromTier(tier2);
        if (p > best) {
          best = p;
        }
      }
    }
    return best;
  };
  return {
    tiers: sorted,
    tier,
    nextTier,
    lastTier,
    hasLastTier,
    countToNextTier,
    tiersMaxProducts,
    getEffectiveTierDiscountPercent,
  };
}
const selectors = {
  progressBar: ".progress-bar",
  progressBarWrapper: ".progress-bar--items",
  progressBarItem: ".progress-bar--item",
  progressBarLine: ".progress-line__active",
  removeBtn: ".button__remove",
  messageInitial: ".tiers-description--initial",
  messageInitialLeft: ".tiers-description--left",
  messageInitiallabel: ".tiers-description--label",
  messageInitialDiscount: ".tiers-description--discount",
  messageCompleted: ".tiers-description--completed",
};
function updateDrawerMessage(tiers, products, discountType, boxData) {
  const cartTotal = isCartTotalThreshold(boxData);
  let currentValue;
  if (cartTotal) {

    const subtotalData = typeof window.juoBoxCart?.getSubtotal === "function"
      ? window.juoBoxCart.getSubtotal({ forceSubscribed: false })
      : null;
    currentValue = subtotalData ? subtotalData.subtotal / 100 : 0;
  } else {
    currentValue = products.length;
  }
  const nextTier = tiers.nextTier(currentValue);
  const tiersDescriptionInitial = document.querySelector(
    selectors.messageInitial
  );
  const tiersDescriptionCompleted = document.querySelector(
    selectors.messageCompleted
  );
  if (nextTier != null && tiersDescriptionInitial != null) {
    const leftEl = tiersDescriptionInitial.querySelector(
      selectors.messageInitialLeft
    );
    if (leftEl != null) {
      if (cartTotal) {
        const nextMin = tierCartTotalThreshold(nextTier);
        const left = Math.max(0, nextMin - currentValue);
        leftEl.textContent = formatCurrency(Math.ceil(left * 100) / 100);
      } else {
        const nextMin = tierMinimumProductsCount(nextTier);
        leftEl.textContent = String(Math.max(0, nextMin - currentValue));
      }
    }
    const discountEl = tiersDescriptionInitial.querySelector(
      selectors.messageInitialDiscount
    );
    if (discountEl != null) {
      const dt2 = (discountType || "").toUpperCase();
      const tierVal = parseTierPercentFromTier(nextTier);
      if (dt2 === "FIXED_AMOUNT") {
        discountEl.textContent = formatCurrency(tierVal);
      } else if (dt2 === "PRICE") {
        discountEl.textContent = formatCurrency(tierVal);
      } else {
        discountEl.textContent = String(nextTier.value);
      }
    }
    const label = tiersDescriptionInitial.querySelector(
      selectors.messageInitiallabel
    );
    if (label != null) {
      if (cartTotal) {

        label.textContent = "";
      } else {
        const nextMin = tierMinimumProductsCount(nextTier);
        label.textContent =
          (nextMin - currentValue > 1
            ? tiersDescriptionInitial.dataset.pluralLabel
            : tiersDescriptionInitial.dataset.singularLabel) ?? "product(s)";
      }
    }
  }
  if (tiersDescriptionCompleted != null) {
    tiersDescriptionCompleted.style.display =
      nextTier == null ? "block" : "none";
  }
  if (tiersDescriptionInitial != null) {
    tiersDescriptionInitial.style.display = nextTier == null ? "none" : "block";
  }
}
function updateProgressLine(progressBarWrapper, totalQty) {
  let progressWidth = 0;
  const activeEls = progressBarWrapper.querySelectorAll(
    `${selectors.progressBarItem}.active`
  );
  activeEls.forEach((item) => {
    progressWidth +=
      item.offsetWidth + parseInt(window.getComputedStyle(item).marginRight);
  });
  const progressLine = document.querySelector(selectors.progressBarLine);
  if (progressLine != null) {
    progressLine.style.width = `${progressWidth}px`;
  }
  if (activeEls != null) {
    const activeItem = document.querySelector(
      `${selectors.progressBarItem}.active`
    );
    const figure = document.querySelector(
      `${selectors.progressBarItem}.active figure`
    );
    const progressBar = document.querySelector(selectors.progressBar);
    if (activeItem == null || figure == null || progressBar == null) {
      return;
    }
    const scrollPos =
      (totalQty - 1) *
        (figure.offsetWidth +
          parseInt(window.getComputedStyle(activeItem).marginRight)) -
      progressBar.offsetWidth;
    progressBar.scrollLeft = scrollPos;
  }
}
function populateProgressBar(products) {
  const progressBarWrapper = document.querySelector(
    selectors.progressBarWrapper
  );
  if (progressBarWrapper == null) {
    return;
  }
  const slotsCount = progressBarWrapper.querySelectorAll(
    selectors.progressBarItem
  ).length;
  const filledItemsCount = products.length;
  if (filledItemsCount > slotsCount - 2) {
    const lastItem = progressBarWrapper.querySelector(
      `${selectors.progressBarItem}:last-child`
    );
    if (lastItem != null) {
      for (let i = 0; i < filledItemsCount - slotsCount + 2; i++) {
        const newSlot = lastItem.cloneNode(true);
        progressBarWrapper.appendChild(newSlot);
      }
    }
  }
  if (products.length > 0) {
    products.forEach((product, index2) => {
      progressBarWrapper
        .querySelectorAll(selectors.progressBarItem)
        .forEach((slot, slotIndex) => {
          const removeBtn = slot.querySelector("[data-remove-from-box]");
          if (index2 === slotIndex) {
            slot.classList.add("active");
            if (removeBtn != null) {
              removeBtn.dataset.variantId = product.variantId;
            }
            const currentImg = slot.querySelector("figure img");
            if (
              !(currentImg == null
                ? void 0
                : currentImg.src.includes(product.imageURL))
            ) {
              const imgEl = document.createElement("img");
              imgEl.src = product.imageURL;
              const figureEl = slot.querySelector("figure");
              if (figureEl != null) {
                figureEl.innerHTML = "";
                figureEl.append(imgEl);
              }
            }
          } else if (slotIndex >= products.length) {
            slot.classList.remove("active");
          }
        });
    });
  } else {
    const firstSlot = progressBarWrapper.querySelector(
      `${selectors.progressBarItem}:nth-child(2)`
    );
    firstSlot == null ? void 0 : firstSlot.classList.remove("active");
    const slotImg = firstSlot == null ? void 0 : firstSlot.querySelector("figure");
    if (slotImg != null) {
      slotImg.innerHTML = "";
    }
  }
  updateProgressLine(progressBarWrapper, products.length);
}
function babTierBadgeLabel(tier, discountType) {
  const dt = (discountType || "").toUpperCase();
  const val = parseTierPercentFromTier(tier);
  if (val <= 0) return "—";
  if (dt === "FIXED_AMOUNT") {
    return `- ${formatCurrency(val)}`;
  }
  if (dt === "PRICE") {
    return formatCurrency(val);
  }
  return `${Math.round(val)}% OFF`;
}

function babTierDisplayLabel(tier, discountType) {
  if (tier == null) {
    return "—";
  }
  const customKeys = [
    "label",
    "badge",
    "badgeText",
    "title",
    "name",
    "shortLabel",
    "displayLabel",
    "discountLabel",
    "tierLabel",
    "publicLabel",
  ];
  for (let i = 0; i < customKeys.length; i++) {
    const v = tier[customKeys[i]];
    if (v != null && String(v).trim() !== "") {
      return String(v).trim();
    }
  }
  return babTierBadgeLabel(tier, discountType);
}

function escapeHtmlTierLabel(s) {
  return String(s)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

function tierUnitWordForBabSubtitleEn(boxData) {
  const raw =
    boxData && boxData.tiersThresholdType != null
      ? String(boxData.tiersThresholdType)
      : "";
  const type = raw.toLowerCase().replace(/\s+/g, "_");
  const isUnique =
    type.includes("distinct") ||
    type.includes("unique") ||
    type.includes("different_flavor") ||
    type.includes("different_flavour") ||
    type.includes("differentflavor");
  return isUnique ? "unique flavours" : "pieces";
}

function buildBabSubtitleFromTiers(boxData) {
  if (boxData == null || !Array.isArray(boxData.tiers)) {
    return "";
  }
  const cartTotal = isCartTotalThreshold(boxData);
  const getMin = (tier) => tierGetThreshold(tier, boxData);
  const sorted = [...boxData.tiers].sort((a, b) => getMin(a) - getMin(b));
  const dt = (boxData.boxDiscountType || "").toUpperCase();
  const isFixed = dt === "FIXED_AMOUNT";
  const isPrice = dt === "PRICE";
  const segments = [];
  let maxVal = 0;
  for (let i = 0; i < sorted.length; i++) {
    const tier = sorted[i];
    const min = getMin(tier);
    const val = parseTierPercentFromTier(tier);
    if (min <= 0 || val <= 0) {
      continue;
    }
    maxVal = Math.max(maxVal, val);
    segments.push({ min, val });
  }
  if (segments.length === 0) {
    return "";
  }
  const minLabel = (min) => cartTotal ? formatCurrency(min) : `${min} ${tierUnitWordForBabSubtitleEn(boxData)}`;
  if (isPrice) {
    const parts = segments.map((s) => `${formatCurrency(s.val)} from ${minLabel(s.min)}`);
    return parts.join(" · ") + ".";
  }
  if (isFixed) {
    if (segments.length === 1) {
      const s = segments[0];
      return `From ${minLabel(s.min)}: save ${formatCurrency(s.val)}.`;
    }
    const parts = segments.map((s) => `${formatCurrency(s.val)} from ${minLabel(s.min)}`);
    return `Save up to ${formatCurrency(maxVal)} — ${parts.join(" · ")}.`;
  }
  if (segments.length === 1) {
    const s = segments[0];
    return `From ${minLabel(s.min)}: ${Math.round(s.val)}% off.`;
  }
  const parts = segments.map((s) => `${Math.round(s.val)}% from ${minLabel(s.min)}`);
  return `Up to ${Math.round(maxVal)}% discount — ${parts.join(" · ")}.`;
}

function tierBadgeHorizontalAlign(leftPct) {
  const x = Number(leftPct);
  if (!Number.isFinite(x)) {
    return "center";
  }
  if (x <= 6) {
    return "start";
  }
  if (x >= 94) {
    return "end";
  }
  return "center";
}

function applyBabSubtitle(boxData) {
  const el = document.querySelector('[data-ref="bab-subtitle"]');
  if (el == null || boxData == null) {
    return;
  }
  const text =
    boxData.babThemeSubtitleFallback != null &&
    String(boxData.babThemeSubtitleFallback).trim() !== ""
      ? String(boxData.babThemeSubtitleFallback).trim()
      : "";
  if (text === "") {
    el.setAttribute("hidden", "");
    el.textContent = "";
    el.removeAttribute("lang");
    return;
  }
  el.removeAttribute("hidden");
  el.textContent = text;
  el.removeAttribute("lang");
}

function tierBadgeLeftPercent(threshold, tiersMaxProducts) {
  const maxQ = Math.max(1, Number(tiersMaxProducts) || 1);
  const th = Math.max(0, Number(threshold) || 0);
  return Math.min(100, Math.max(0, (th / maxQ) * 100));
}

function updateProgressBar(rootEl, data, tiersMaxProducts) {
  const progressBar = rootEl.querySelector('[data-ref="progress-bar"]');
  if (progressBar == null) {
    return;
  }
  const cartTotal = isCartTotalThreshold(data);
  function getCurrentValue() {
    if (cartTotal) {

      let sumCents = 0;
      rootEl.querySelectorAll('input[name^="qty["]').forEach(function (input) {
        const qty = Number.parseInt(input.value, 10) || 0;
        const priceCents = Number.parseInt(input.dataset.variantPrice || '0', 10) || 0;
        sumCents += qty * priceCents;
      });
      return sumCents / 100;
    }
    let qty = 0;
    rootEl.querySelectorAll('input[name^="qty["]').forEach(function (input) {
      qty += Number.parseInt(input.value, 10) || 0;
    });
    return qty;
  }
  const currentValue = getCurrentValue();
  const maxQ = Math.max(1, Number(tiersMaxProducts) || 1);
  const fillPercent = Math.min(100, Math.max(0, (currentValue / maxQ) * 100));
  const fillEl = progressBar.querySelector('[data-ref="bar"]');
  if (fillEl != null) {
    fillEl.style.width = `${fillPercent}%`;
    fillEl.style.display = "block";
    fillEl.style.opacity = "1";
  }
  const track = progressBar.querySelector('[data-ref="tier-track"]');
  if (track != null) {
    track.setAttribute("aria-valuenow", String(Math.round(fillPercent)));
  }
  const rawTiers = Array.isArray(data.tiers) ? data.tiers : [];
  const sorted = [...rawTiers].sort(
    (a, b) => tierGetThreshold(a, data) - tierGetThreshold(b, data)
  );
  progressBar.querySelectorAll('[data-ref="tier-badge"]').forEach(
    (badge, idx) => {
      const tier = sorted[idx];
      if (tier == null) {
        return;
      }
      const th = tierGetThreshold(tier, data);
      if (currentValue >= th) {
        badge.classList.add("bab__tier-badge--active");
        badge.classList.remove("bab__tier-badge--locked");
      } else {
        badge.classList.add("bab__tier-badge--locked");
        badge.classList.remove("bab__tier-badge--active");
      }
    }
  );
}

function renderProgressBar(root, data, tiersMaxProducts) {
  const progressBar = root.querySelector('[data-ref="progress-bar"]');
  if (progressBar == null) {
    return;
  }
  const rawTiers = Array.isArray(data.tiers) ? data.tiers : [];
  const sorted = [...rawTiers].sort(
    (a, b) => tierGetThreshold(a, data) - tierGetThreshold(b, data)
  );
  if (sorted.length === 0) {
    progressBar.innerHTML = "";
    progressBar.setAttribute("hidden", "");
    return;
  }
  progressBar.removeAttribute("hidden");
  const maxQ = Math.max(1, Number(tiersMaxProducts) || 1);
  const badges = sorted
    .map((tier, i) => {
      const th = tierGetThreshold(tier, data);
      const leftPct = tierBadgeLeftPercent(th, maxQ);
      const align = tierBadgeHorizontalAlign(leftPct);
      const discountVal = parseTierPercentFromTier(tier);
      const discountType = data.boxDiscountType ? String(data.boxDiscountType).toUpperCase() : "";
      const label = discountVal > 0
        ? escapeHtmlTierLabel(discountType === "FIXED_AMOUNT" ? `-${discountVal}` : `-${discountVal}%`)
        : escapeHtmlTierLabel(`${th}`);
      return `<span class="bab__tier-badge bab__tier-badge--locked bab__tier-badge--align-${align}" style="left:${leftPct}%;z-index:${
        i + 1
      }" data-tier-index="${i}" data-tier-threshold="${th}" data-tier-left="${leftPct}" data-tier-align="${align}" data-ref="tier-badge">${label}</span>`;
    })
    .join("");
  progressBar.innerHTML = `
    <div class="bab__tier-progress-wrap">
      <div class="bab__tier-labels" data-ref="tier-labels">${badges}</div>
      <div class="bab__tier-track" data-tiers-max="${maxQ}" data-ref="tier-track" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0">
        <div class="bab__tier-fill" data-ref="bar" style="width:0%"></div>
      </div>
    </div>
  `;
}
function formatCurrency(amount) {
  if (window.Shopify == null) {
    return amount;
  }

  const currency = window.Shopify.currency.active;

  const leadingSymbolCurrencies = [
    "USD",
    "CAD",
    "GBP",
    "EUR",
    "CHF",
    "JPY",
    "CNY",
  ];
  const isLeading = leadingSymbolCurrencies.includes(currency);

  const neutralLocale = "en";

  const numberFormatter = new Intl.NumberFormat(neutralLocale, {
    style: "decimal",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  const formattedNumber = numberFormatter.format(amount);

  const tempFormatter = new Intl.NumberFormat(neutralLocale, {
    style: "currency",
    currency: currency,
    currencyDisplay: "narrowSymbol",
  });

  const tempFormatted = tempFormatter.format(0);
  const currencySymbol = tempFormatted.replace(/[0-9.,\s]/g, "").trim();

  return isLeading
    ? `${currencySymbol} ${formattedNumber}`
    : `${formattedNumber} ${currencySymbol}`;
}

function createSellingPlans(boxData, products, isSubscribed, select) {
  const isSimpleProduct =
    (!Array.isArray(boxData.ids) || boxData.ids.length === 0) &&
    (!Array.isArray(boxData.variants) || boxData.variants.length === 0) &&
    (!Array.isArray(boxData.products) || boxData.products.length === 0) &&
    Array.isArray(boxData.sellingPlans) &&
    boxData.sellingPlans.length > 0;

  if (isSimpleProduct) {
    const availablePlans = buildSelectOptionsFromPlansList(
      boxData.sellingPlans
    );

    function sellingPlan() {
      if (typeof isSubscribed !== "function" || select == null) return null;
      if (!isSubscribed()) return null;
      return select.value || null;
    }
    function getSelectedPlanId() {
      return select ? select.value || null : null;
    }

    return {
      productsSellingPlans: [],
      availablePlans,
      sellingPlan,
      getSelectedPlanId,
    };
  }

  const allowedVariantIds = new Set(
    (Array.isArray(boxData.ids) ? boxData.ids : []).map((id) =>
      String(id).trim()
    )
  );
  let eligibleProducts = products.filter((product) =>
    allowedVariantIds.has(String(product.variantId).trim())
  );
  if (eligibleProducts.length === 0 && products.length > 0) {
    eligibleProducts = products;
  }

  function normalizeShopifyId(value) {
    if (value == null || value === "") {
      return "";
    }
    const str = String(value).trim();
    const m = str.match(/(\d+)\s*$/);
    return m ? m[1] : str;
  }

  const dedicatedGroupIdNorm = normalizeShopifyId(
    boxData && boxData.dedicatedSellingPlanGroupId != null
      ? boxData.dedicatedSellingPlanGroupId
      : ""
  );

  const dedicatedPlanNameSet =
    dedicatedGroupIdNorm && Array.isArray(boxData.sellingPlans) && boxData.sellingPlans.length > 0
      ? new Set(
          boxData.sellingPlans
            .map((p) => normalizePlanNameForMatch(p.name))
            .filter(Boolean)
        )
      : new Set();

  function filteredAllocationsForProduct(product) {
    let allocations = (product.sellingPlanAllocations || []).filter(
      (a) => sellingPlanIdFromAllocation(a) != null
    );
    if (dedicatedGroupIdNorm) {
      if (dedicatedPlanNameSet.size > 0) {
        allocations = allocations.filter((a) => {
          const planName = allocationPlanNameNormalized(a);
          return planName !== "" && dedicatedPlanNameSet.has(planName);
        });
      } else {
        allocations = [];
      }
    }
    return allocations;
  }

  if (
    Array.isArray(boxData.rawBoxSellingPlanIds) &&
    boxData.rawBoxSellingPlanIds.length > 0
  ) {
    const requiredIds = boxData.rawBoxSellingPlanIds;
    const someProductMissingPlan = eligibleProducts.some((product) => {
      const productPlanIds = new Set(
        filteredAllocationsForProduct(product)
          .map((a) => sellingPlanIdFromAllocation(a))
          .filter(Boolean)
      );
      return requiredIds.some((id) => !productPlanIds.has(id));
    });
    if (someProductMissingPlan) {
      return {
        productsSellingPlans: [],
        availablePlans: [],
        noCommonPlans: true,
        sellingPlan: function () { return null; },
        getSelectedPlanId: function () { return select ? select.value || null : null; },
      };
    }
  }

  const perProductNameSets = eligibleProducts
    .map((product) => {
      const allocations = filteredAllocationsForProduct(product);
      if (!allocations.length) {
        return null;
      }
      const set = new Set();
      allocations.forEach((a) => {
        const n = allocationPlanNameNormalized(a);
        if (n) {
          set.add(n);
        }
      });
      return set.size ? set : null;
    })
    .filter(Boolean);

  if (perProductNameSets.length < eligibleProducts.length) {
    function sellingPlanNone() {
      return null;
    }
    function getSelectedPlanIdNone() {
      return select ? select.value || null : null;
    }
    return {
      productsSellingPlans: [],
      availablePlans: [],
      noCommonPlans: true,
      sellingPlan: sellingPlanNone,
      getSelectedPlanId: getSelectedPlanIdNone,
    };
  }

  if (!perProductNameSets.length) {
    function sellingPlan() {
      if (typeof isSubscribed !== "function" || select == null) {
        return null;
      }
      if (!isSubscribed()) {
        return null;
      }
      return select.value || null;
    }
    function getSelectedPlanId() {
      return select ? select.value || null : null;
    }
    return {
      productsSellingPlans: [],
      availablePlans: [],
      sellingPlan,
      getSelectedPlanId,
    };
  }

  let commonNames = new Set(perProductNameSets[0]);
  for (let i = 1; i < perProductNameSets.length; i++) {
    for (const n of Array.from(commonNames)) {
      if (!perProductNameSets[i].has(n)) {
        commonNames.delete(n);
      }
    }
  }

  const availablePlans = [];
  for (const nameKey of commonNames) {
    let sampleAlloc = null;
    for (const product of eligibleProducts) {
      const allocs = filteredAllocationsForProduct(product);
      const found = allocs.find(
        (a) => allocationPlanNameNormalized(a) === nameKey
      );
      if (found) {
        sampleAlloc = found;
        break;
      }
    }
    const displayName = sampleAlloc
      ? allocationPlanNameFromAllocation(sampleAlloc).trim()
      : nameKey;
    const bundlePlan = (boxData.sellingPlans || []).find(
      (p) => normalizePlanNameForMatch(p.name) === nameKey
    );
    const planForDiscount = bundlePlan || {
      id: sampleAlloc ? sellingPlanIdFromAllocation(sampleAlloc) : "",
      name: displayName,
      price_adjustments:
        sampleAlloc &&
        sampleAlloc.selling_plan &&
        sampleAlloc.selling_plan.price_adjustments != null
          ? sampleAlloc.selling_plan.price_adjustments
          : null,
      recurring_deliveries:
        sampleAlloc &&
        sampleAlloc.selling_plan &&
        sampleAlloc.selling_plan.recurring_deliveries !== undefined
          ? sampleAlloc.selling_plan.recurring_deliveries
          : undefined,
    };
    if (planForDiscount.recurring_deliveries === false) {
      continue;
    }
    const { discountValue, discountType } =
      extractSellingPlanDiscountFields(planForDiscount);
    const idValue = bundlePlan
      ? normalizeSellingPlanIdString(bundlePlan.id)
      : sampleAlloc
        ? sellingPlanIdFromAllocation(sampleAlloc)
        : "";
    if (!idValue) {
      continue;
    }
    availablePlans.push({
      id: String(idValue),
      name: displayName,
      discountValue,
      discountType,
    });
  }

  function sellingPlan() {
    if (typeof isSubscribed !== "function" || select == null) {
      return null;
    }
    if (!isSubscribed()) {
      return null;
    }
    return select.value || null;
  }
  function getSelectedPlanId() {
    return select ? select.value || null : null;
  }

  return {
    productsSellingPlans: [],
    availablePlans,
    sellingPlan,
    getSelectedPlanId,
  };
}
function parsePrice(value) {
  if (!value) return null;
  const normalized = value
    .replace(/\s/g, "")
    .replace(/\.(?=\d{3})/g, "")
    .replace(",", ".")
    .replace(/[^0-9.-]+/g, "");
  const parsed = parseFloat(normalized);
  return Number.isNaN(parsed) ? null : parsed;
}

function extractSellingPlanDiscountFields(plan) {
  if (!plan || plan.price_adjustments == null) {
    return { discountValue: null, discountType: null };
  }
  let adj = plan.price_adjustments;
  if (Array.isArray(adj)) {
    adj = adj[0];
  }
  if (!adj || typeof adj !== "object") {
    return { discountValue: null, discountType: null };
  }
  const rawType = adj.value_type != null ? adj.value_type : adj.valueType;
  const vt =
    rawType != null ? String(rawType).toLowerCase() : "";
  const val = adj.value;
  if ((vt === "percentage" || vt === "fixed_amount") && val != null) {
    return { discountValue: val, discountType: vt };
  }
  return { discountValue: null, discountType: null };
}

function getSelectedSellingPlanDiscountPercent() {
  const planSelect = document.querySelector(
    '#juo-subscription-widget [data-ref="selling-plan"]'
  );
  if (!planSelect || !planSelect.value) {
    return null;
  }
  const opt = planSelect.selectedOptions[0];
  if (opt) {
    const dt = String(opt.dataset.discountType || "").toLowerCase();
    const dv = Number.parseFloat(opt.dataset.discountValue || "");
    if (dt === "percentage" && Number.isFinite(dv) && dv > 0 && dv < 100) {
      return dv;
    }
  }
  const planId = Number.parseInt(String(planSelect.value), 10);
  if (!Number.isFinite(planId)) {
    return null;
  }
  const dataEl = document.getElementById("juo-subscription-widget-data");
  if (!dataEl) {
    return null;
  }
  try {
    const raw = JSON.parse(dataEl.textContent || dataEl.innerText || "[]");
    const variants = Array.isArray(raw) ? raw[0] : null;
    if (!Array.isArray(variants)) {
      return null;
    }
    for (let vi = 0; vi < variants.length; vi++) {
      const plans = variants[vi].sellingPlans || [];
      for (let pi = 0; pi < plans.length; pi++) {
        const p = plans[pi];
        if (p && Number(p.id) === planId && p.discountPercent != null) {
          const pct = Number(p.discountPercent);
          if (Number.isFinite(pct) && pct > 0 && pct < 100) {
            return pct;
          }
        }
      }
    }
  } catch (e) {
    return null;
  }
  return null;
}

function getSelectedSellingPlanDiscount() {
  const planSelect = document.querySelector(
    '#juo-subscription-widget [data-ref="selling-plan"]'
  );
  if (!planSelect || !planSelect.value) return null;
  const opt = planSelect.selectedOptions[0];
  if (!opt) return null;
  const dt = String(opt.dataset.discountType || "").toLowerCase();
  const dv = Number.parseFloat(opt.dataset.discountValue || "");
  if ((dt === "percentage" || dt === "fixed_amount") && Number.isFinite(dv) && dv > 0) {
    return { type: dt, value: dv };
  }
  return null;
}

function getFirstLineAllocationPriceCentsFromBoxData() {
  const dataEl = document.getElementById("juo-box-data");
  const firstInput = document.querySelector(
    ".box-builder__products-list .product-qty-input"
  );
  const planSelect = document.querySelector(
    '#juo-subscription-widget [data-ref="selling-plan"]'
  );
  if (!dataEl || !firstInput || !planSelect || !planSelect.value) {
    return null;
  }
  const variantId = String(firstInput.dataset.variant || "");
  if (!variantId) {
    return null;
  }
  let parsed;
  try {
    parsed = JSON.parse(dataEl.textContent || dataEl.innerText || "{}");
  } catch (e) {
    return null;
  }
  const variant = (parsed.variants || []).find(
    (v) => String(v.id) === variantId
  );
  const allocations = variant && variant.selling_plan_allocations;
  if (!variant || !Array.isArray(allocations) || !allocations.length) {
    return null;
  }
  const planId = String(planSelect.value);
  let allocation = allocations.find(
    (a) => String(a.selling_plan_id) === planId
  );
  if (!allocation) {
    allocation = allocations.find(
      (a) => Number(a.selling_plan_id) === Number(planSelect.value)
    );
  }
  if (!allocation) {
    return null;
  }
  const raw = allocation.price;
  if (raw == null) {
    return null;
  }
  const cents = moneyFieldToCents(raw);
  return cents >= 0 ? cents : null;
}

function getJuoBoxFreeVariantId() {
  const el = document.getElementById("juo-box-data");
  if (el == null) {
    return null;
  }
  try {
    const p = JSON.parse(el.textContent || el.innerText || "{}");
    const fp = p.freeProduct;
    if (fp != null && fp.id != null) {
      return String(fp.id);
    }
    if (p.product != null && p.product.freeId != null) {
      return String(p.product.freeId);
    }
  } catch {
    return null;
  }
  return null;
}

function filterCartBoxParentItems(items, parentProductId, freeVariantId) {
  return (items || []).filter((it) => {
    if (String(it.properties?._parent_product_id || "") !== String(parentProductId)) {
      return false;
    }
    if (
      freeVariantId != null &&
      String(it.variant_id) === String(freeVariantId)
    ) {
      return false;
    }
    return true;
  });
}

function sumDomSignatureQty(domSig) {
  return Object.keys(domSig).reduce((s, k) => {
    return s + (Number(domSig[k]) || 0);
  }, 0);
}

function getDomBoxQuantitySignature(safeBaseQty) {
  const mult =
    Number.isFinite(safeBaseQty) && safeBaseQty > 0 ? safeBaseQty : 1;
  const map = {};
  document
    .querySelectorAll(".box-builder__products-list .product-qty-input")
    .forEach((el) => {
      const id = el.dataset.variant;
      if (!id) {
        return;
      }
      const q = Number.parseInt(el.value || "0", 10) || 0;
      if (q <= 0) {
        return;
      }
      const k = String(id);
      map[k] = (map[k] || 0) + q * mult;
    });
  return map;
}

function cartBoxSignatureMatchesDom(boxItems, domSig) {
  const cartSig = {};
  boxItems.forEach((it) => {
    const k = String(it.variant_id);
    cartSig[k] = (cartSig[k] || 0) + (Number(it.quantity) || 0);
  });
  const domKeys = Object.keys(domSig);
  const cartKeys = Object.keys(cartSig);
  if (domKeys.length === 0 || domKeys.length !== cartKeys.length) {
    return false;
  }
  return domKeys.every(
    (k) => (Number(domSig[k]) || 0) === (Number(cartSig[k]) || 0)
  );
}

function sumCartLineMoney(cartItems) {
  let sub = 0;
  let cmp = 0;
  cartItems.forEach((it) => {
    const fin =
      it.final_line_price != null ? it.final_line_price : it.line_price || 0;
    const orig =
      it.original_line_price != null ? it.original_line_price : it.line_price || fin;
    sub += Number(fin) || 0;
    cmp += Number(orig) || 0;
  });
  return {
    subtotalCents: Math.round(sub),
    compareCents: Math.round(cmp),
  };
}

function extractBoxTotalsFromCartIfMatches(cart, parentProductId, domSig) {
  if (!cart || !parentProductId) {
    return null;
  }
  const freeVid = getJuoBoxFreeVariantId();
  const items = filterCartBoxParentItems(
    cart.items || [],
    parentProductId,
    freeVid
  );
  if (items.length === 0 || !cartBoxSignatureMatchesDom(items, domSig)) {
    return null;
  }
  return sumCartLineMoney(items);
}

function extractBoxTotalsFromCartByTotalQty(cart, parentProductId, domSig) {
  if (!cart || !parentProductId) {
    return null;
  }
  const freeVid = getJuoBoxFreeVariantId();
  const items = filterCartBoxParentItems(
    cart.items || [],
    parentProductId,
    freeVid
  );
  if (items.length === 0) {
    return null;
  }
  const expected = sumDomSignatureQty(domSig);
  const cartQty = items.reduce((s, it) => {
    return s + (Number(it.quantity) || 0);
  }, 0);
  if (expected <= 0 || cartQty !== expected) {
    return null;
  }
  return sumCartLineMoney(items);
}

async function fetchCartBoxOverrideTotals(parentProductId, domSig) {
  if (
    typeof window === "undefined" ||
    !window.Shopify ||
    !window.Shopify.routes ||
    !parentProductId ||
    Object.keys(domSig).length === 0
  ) {
    return null;
  }
  try {
    const root = window.Shopify.routes.root || "/";
    const res = await fetch(`${root}cart.js`, { cache: "no-store" });
    if (!res.ok) {
      return null;
    }
    const cart = await res.json();
    const strict = extractBoxTotalsFromCartIfMatches(
      cart,
      parentProductId,
      domSig
    );
    if (strict != null) {
      return strict;
    }
    return extractBoxTotalsFromCartByTotalQty(cart, parentProductId, domSig);
  } catch {
    return null;
  }
}

let _widgetPriceTimer = null;
function updateWidgetPrice() {
  clearTimeout(_widgetPriceTimer);
  _widgetPriceTimer = setTimeout(_updateWidgetPriceCore, 60);
}
function _updateWidgetPriceCore() {
    const boxBuilder = document.querySelector(".box-builder");
    const safeBaseQty = getParentProductQuantityMultiplier();
    const subDiscount = parseFloat(boxBuilder?.dataset.subDiscount || "0");
    const subDiscountType = (boxBuilder?.dataset.subDiscountType || "percentage").toLowerCase();

    const isBoxBuilderWidget =
      document.getElementById("juo-subscription-widget")?.dataset.boxBuilder ===
      "true";
    let boxQtySum = 0;
    if (boxBuilder) {
      document
        .querySelectorAll(".box-builder__products-list .product-qty-input")
        .forEach((el) => {
          boxQtySum += Number.parseInt(el.value || "0", 10) || 0;
        });
    }

    const isSubscribed = Boolean(
      document.querySelector(
        '#juo-subscription-widget input[name="mode"]:checked'
      )?.value === "subscription"
    );
    const hasLiveCalc = typeof window.juoBoxCart?.getSubtotal === "function";
    const planSelectEl = document.querySelector(
      '#juo-subscription-widget [data-ref="selling-plan"]'
    );
    const planId = planSelectEl && planSelectEl.value ? planSelectEl.value : null;

    let boxOtpTotalCents = 0;
    let boxOtpCompareCents = 0;
    let boxSubTotalCents = 0;
    let boxSubCompareCents = 0;
    let boxOtpLineSumCents = 0;

    if (isBoxBuilderWidget) {
      const firstFlavorInput = document.querySelector(
        ".box-builder__products-list .product-qty-input"
      );
      let otpSumCents = 0;
      if (boxQtySum > 0) {
        document
          .querySelectorAll(".box-builder__products-list .product-qty-input")
          .forEach((el) => {
            const q = Number.parseInt(el.value || "0", 10) || 0;
            const lineCents =
              Number.parseInt(el.dataset.variantPrice || "0", 10) || 0;
            otpSumCents += q * lineCents;
          });
        otpSumCents *= safeBaseQty;
      } else if (firstFlavorInput) {
        const lineCents =
          Number.parseInt(firstFlavorInput.dataset.variantPrice || "0", 10) || 0;
        otpSumCents = lineCents * safeBaseQty;
      }
      boxOtpLineSumCents = otpSumCents;

      if (boxQtySum > 0 && hasLiveCalc) {
        const liveOtp = window.juoBoxCart.getSubtotal({ forceSubscribed: false });
        boxOtpTotalCents = Math.round(liveOtp.subtotal * safeBaseQty);
        boxOtpCompareCents = Math.max(otpSumCents, Math.round(liveOtp.compareToPrice * safeBaseQty));

        const liveSub = window.juoBoxCart.getSubtotal({
          forceSubscribed: true,
          forceSellingPlanId: planId,
        });
        boxSubTotalCents = Math.round(liveSub.subtotal * safeBaseQty);
        boxSubCompareCents = Math.max(otpSumCents, Math.round(liveSub.compareToPrice * safeBaseQty));
      } else if (boxQtySum > 0) {

        const planDiscount = getSelectedSellingPlanDiscount();
        if (planDiscount != null && otpSumCents > 0) {
          if (planDiscount.type === "fixed_amount") {
            boxSubTotalCents = Math.max(0, otpSumCents - Math.round(planDiscount.value * boxQtySum * safeBaseQty));
          } else {
            boxSubTotalCents = Math.round(otpSumCents * (1 - planDiscount.value / 100));
          }
          boxSubCompareCents = otpSumCents;
        } else {
          boxSubTotalCents = otpSumCents;
          boxSubCompareCents = otpSumCents;
        }
        boxOtpTotalCents = otpSumCents;
        boxOtpCompareCents = otpSumCents;
      } else {

        const allocUnitCents = getFirstLineAllocationPriceCentsFromBoxData();
        if (allocUnitCents != null) {
          boxSubTotalCents = Math.round(allocUnitCents * safeBaseQty);
        } else if (Number.isFinite(subDiscount) && subDiscount > 0) {
          if (subDiscountType === "fixed_amount") {
            boxSubTotalCents = Math.max(0, otpSumCents - Math.round(subDiscount * safeBaseQty));
          } else {
            boxSubTotalCents = Math.round(otpSumCents * (1 - subDiscount / 100));
          }
        } else {
          boxSubTotalCents = otpSumCents;
        }
        boxOtpTotalCents = otpSumCents;
        boxOtpCompareCents = otpSumCents;
      }
    }

    let combinedOneTimeCents = 0;
    let combinedSubCents = 0;
    let combinedCompareCents = 0;

    if (isBoxBuilderWidget) {
      const firstFlavorInput = document.querySelector(
        ".box-builder__products-list .product-qty-input"
      );
      const previewPrice =
        firstFlavorInput != null
          ? Number.parseInt(firstFlavorInput.dataset.variantPrice || "0", 10) || 0
          : 0;

      if (boxQtySum <= 0) {
        const otpPreview = previewPrice * safeBaseQty;
        combinedOneTimeCents = otpPreview;

        if (isSubscribed) {
          combinedSubCents = boxSubTotalCents || otpPreview;
          combinedCompareCents = otpPreview;
        } else {
          combinedSubCents = boxSubTotalCents || otpPreview;
          combinedCompareCents = 0;
        }
      } else {
        combinedOneTimeCents = boxOtpTotalCents;
        combinedSubCents = boxSubTotalCents;
        combinedCompareCents = boxSubCompareCents;
      }
    } else {
      let basePriceCents = Number.parseInt(boxBuilder?.dataset.basePrice || "0", 10);
      let baseCompareCents = Number.parseInt(boxBuilder?.dataset.baseCompare || "0", 10);
      if (!baseCompareCents || baseCompareCents < basePriceCents) {
        baseCompareCents = basePriceCents;
      }
      basePriceCents *= safeBaseQty;
      baseCompareCents *= safeBaseQty;
      combinedOneTimeCents = basePriceCents;
      const baseSubCents = Number.isFinite(subDiscount)
        ? Math.round(basePriceCents * (1 - subDiscount / 100))
        : basePriceCents;
      combinedSubCents = baseSubCents;
      combinedCompareCents = baseCompareCents;
    }

    const oneTimePriceEl = document.querySelector(
      "#juo-subscription-widget .j-otp [part~='price--base'] .money"
    );
    if (oneTimePriceEl) {
      oneTimePriceEl.textContent = formatCurrency(combinedOneTimeCents / 100);
    }

    const subscriptionPriceEl = document.querySelector(
      '#juo-subscription-widget [data-ref="subscription-total-money"]'
    );
    if (subscriptionPriceEl) {
      subscriptionPriceEl.textContent = formatCurrency(combinedSubCents / 100);
    }

    const subscriptionCompareEl = document.querySelector(
      "#juo-subscription-widget .j-subscription .j-compare-price .money"
    );
    if (subscriptionCompareEl) {
      subscriptionCompareEl.textContent = formatCurrency(
        combinedCompareCents / 100
      );
    }

    const compareIsValid =
      combinedCompareCents > 0 && combinedCompareCents > combinedSubCents;
    const subscriptionCompare = document.querySelector(
      "#juo-subscription-widget .j-subscription .j-compare-price"
    );
    if (subscriptionCompare) {
      subscriptionCompare.style.setProperty(
        "display",
        compareIsValid ? "inline" : "none",
        "important"
      );
    }

    const saveBadge = document.querySelector(
      "#juo-subscription-widget [data-ref='save-badge']"
    );
    if (saveBadge && compareIsValid) {
      const boxBuilderElBadge = document.querySelector(".box-builder");
      const badgeDiscType = (boxBuilderElBadge?.dataset.boxDiscountType || "").toLowerCase();
      if (badgeDiscType === "fixed_amount") {
        const saveBase =
          isBoxBuilderWidget && isSubscribed && boxQtySum > 0 && boxOtpLineSumCents > 0
            ? boxOtpLineSumCents
            : combinedCompareCents;
        const savedCents = saveBase - combinedSubCents;
        saveBadge.innerHTML = `- ${formatCurrency(savedCents / 100)}`;
      } else {
        let percent = Math.round(
          100 - (combinedSubCents / combinedCompareCents) * 100
        );
        if (
          isBoxBuilderWidget &&
          isSubscribed &&
          boxQtySum > 0 &&
          boxOtpLineSumCents > 0 &&
          combinedSubCents < boxOtpLineSumCents
        ) {
          percent = Math.round(
            100 - (combinedSubCents / boxOtpLineSumCents) * 100
          );
        }
        saveBadge.innerHTML = `<span data-ref="save">${percent}</span>%`;
      }
      saveBadge.style.display = "inline-flex";
    } else if (saveBadge) {
      saveBadge.style.display = "none";
    }

    const subWidget = document.getElementById("juo-subscription-widget");
    if (subWidget && subWidget.dataset.boxBuilder === "true") {
      const cupsPerPack =
        Number.parseInt(subWidget.dataset.cupsPerPack || "60", 10) || 60;
      const cupsUnit = subWidget.dataset.cupsUnit || "cups";
      const perCupConnector = subWidget.dataset.perCupConnector || "per";
      const perCupUnit = subWidget.dataset.perCupUnit || "cup";

      const cupSepSelectors =
        "#juo-subscription-widget .j-subscription-pill > .j-price-sep, #juo-subscription-widget .j-compare-line .j-price-sep, #juo-subscription-widget .j-otp-price-line > .j-price-sep";
      const perCupSelectors =
        '[data-ref="subscription-per-cup"], [data-ref="otp-per-cup"], [data-ref="subscription-compare-per-cup"]';

      const totalCups =
        boxQtySum <= 0
          ? cupsPerPack * safeBaseQty
          : boxQtySum * cupsPerPack * safeBaseQty;
      subWidget.dataset.cups = String(Math.max(0, totalCups));

      document
        .querySelectorAll("#juo-subscription-widget .j-cups")
        .forEach((el) => {
          el.style.display = "";
        });
      document.querySelectorAll(perCupSelectors).forEach((el) => {
        el.style.display = "";
      });
      document.querySelectorAll(cupSepSelectors).forEach((el) => {
        el.style.display = "";
      });

      const formatPerCupLine = (totalCents) => {
        if (totalCups <= 0 || !Number.isFinite(totalCents)) {
          return `— ${perCupConnector} ${perCupUnit}`;
        }
        const per = Math.round(totalCents / totalCups);
        return `${formatCurrency(per / 100)} ${perCupConnector} ${perCupUnit}`;
      };

      const perBagLabel = subWidget.dataset.perBagLabel || "per bag";
      const bagsUnitSingular = subWidget.dataset.bagsUnitSingular || "bag";
      const bagsUnit = subWidget.dataset.bagsUnit || "bags";
      const bagsLabel = boxQtySum === 1 ? bagsUnitSingular : bagsUnit;

      const submitButtons = [
        document.querySelector(".go-to-checkout"),
        document.querySelector("#sticky-atc-button"),
        document.querySelector("form.product-form button[type='submit'], form.product-single__form button[type='submit'], form[data-type='add-to-cart-form'] button[type='submit']"),
      ].filter(Boolean);

      if (boxQtySum <= 0) {
        document.querySelectorAll("#juo-subscription-widget .j-cups").forEach((el) => { el.textContent = ""; });
        document.querySelectorAll("#juo-subscription-widget .j-bags").forEach((el) => { el.textContent = ""; });
        submitButtons.forEach((btn) => { btn.disabled = true; btn.classList.add("disabled"); });
      } else {
        const formatPricePerBag = (totalCents) => {
          if (totalCents <= 0) return null;
          return formatCurrency(totalCents / 100 / boxQtySum);
        };

        const subFormatted = formatPricePerBag(combinedSubCents);
        document
          .querySelectorAll("#juo-subscription-widget .j-subscription .j-cups")
          .forEach((el) => {
            el.textContent = subFormatted
              ? `${subFormatted} / ${perBagLabel}`
              : `${totalCups} ${cupsUnit}`;
          });

        const otpFormatted = formatPricePerBag(combinedOneTimeCents);
        document
          .querySelectorAll("#juo-subscription-widget .j-otp .j-cups")
          .forEach((el) => {
            el.textContent = otpFormatted
              ? `${otpFormatted} / ${perBagLabel}`
              : `${totalCups} ${cupsUnit}`;
          });

        document
          .querySelectorAll("#juo-subscription-widget .j-bags")
          .forEach((el) => {
            el.textContent = `${boxQtySum} ${bagsLabel}`;
          });

      }

      const subPerCupEl = document.querySelector(
        '[data-ref="subscription-per-cup"]'
      );
      const otpPerCupEl = document.querySelector('[data-ref="otp-per-cup"]');
      const cmpPerCupEl = document.querySelector(
        '[data-ref="subscription-compare-per-cup"]'
      );
      if (subPerCupEl) {
        subPerCupEl.textContent = formatPerCupLine(combinedSubCents);
      }
      if (otpPerCupEl) {
        otpPerCupEl.textContent = formatPerCupLine(combinedOneTimeCents);
      }
      if (cmpPerCupEl) {
        cmpPerCupEl.textContent = formatPerCupLine(combinedCompareCents);
      }

      let psSaleCents = isSubscribed ? combinedSubCents : combinedOneTimeCents;
      let psCmpCents = combinedCompareCents;
      if (boxQtySum > 0 && hasLiveCalc) {
        const t = isSubscribed
          ? window.juoBoxCart.getSubtotal({
              forceSubscribed: true,
              forceSellingPlanId: planId,
            })
          : window.juoBoxCart.getSubtotal({ forceSubscribed: false });
        psSaleCents = Math.round(t.subtotal * safeBaseQty);
        psCmpCents = Math.round(t.compareToPrice * safeBaseQty);
      }

      if (isSubscribed && boxQtySum > 0 && boxOtpLineSumCents > 0) {
        psCmpCents = boxOtpLineSumCents;
      }

      const purchaseSummaryRoot = document.querySelector(
        '[data-ref="purchase-summary"]'
      );
      if (purchaseSummaryRoot) {
        const totalEl = purchaseSummaryRoot.querySelector(
          '[data-ref="purchase-summary-total"]'
        );
        const cmpWrap = purchaseSummaryRoot.querySelector(
          '[data-ref="purchase-summary-compare-wrap"]'
        );
        const cmpEl = purchaseSummaryRoot.querySelector(
          '[data-ref="purchase-summary-compare"]'
        );
        const badge = purchaseSummaryRoot.querySelector(
          '[data-ref="purchase-summary-badge"]'
        );
        const perCupSummaryEl = purchaseSummaryRoot.querySelector(
          '[data-ref="purchase-summary-per-cup"]'
        );
        if (totalEl) {
          totalEl.textContent = formatCurrency(psSaleCents / 100);
        }
        const showCmp =
          psCmpCents > 0 &&
          psCmpCents > psSaleCents &&
          Number.isFinite(psCmpCents);
        if (cmpWrap) {
          cmpWrap.hidden = !showCmp;
        }
        if (cmpEl && showCmp) {
          cmpEl.textContent = formatCurrency(psCmpCents / 100);
        }
        if (badge) {
          if (showCmp) {
            badge.hidden = false;
            const boxBuilderEl = document.querySelector(".box-builder");
            const discType = (boxBuilderEl?.dataset.boxDiscountType || "").toLowerCase();
            if (discType === "fixed_amount") {
              const savedCents = psCmpCents - psSaleCents;
              badge.innerHTML = `- ${formatCurrency(savedCents / 100)}`;
            } else {
              badge.innerHTML = `<span data-ref="purchase-summary-pct">${Math.round(100 - (psSaleCents / psCmpCents) * 100)}</span>%`;
            }
          } else {
            badge.hidden = true;
          }
        }
        if (perCupSummaryEl) {
          perCupSummaryEl.textContent = formatPerCupLine(psSaleCents);
        }
      }
    }

    document.dispatchEvent(
      new CustomEvent("juo-subscription:sync-label", { bubbles: true })
    );
}
(function () {
  const selectors2 = {
    addToBox: "[data-add-to-box]",
    changeQty: "button[data-qty-target]",
    builderForm: ".box-builder__products-list",
    subscriptionSelect: "#juo-subscription-widget [data-ref='selling-plan']",
    productItem: ".box-builder__products-list--item",
    qtyInput: ".product-qty-input",
    removeBtn: ".button__remove",
    checkoutBtn: ".go-to-checkout",
    totalPrice: ".juo-box-footer [data-ref='total-price']",
    comparePrice: ".juo-box-footer [data-ref='compare-price']",
    savingsAmount: ".juo-box-footer [data-ref='savings']",
    drawer: ".box-builder__drawer",
  };
  function initBuilder() {
    const boxData = createBoxData();
    if (boxData == null) {
      return;
    }
    applyBabSubtitle(boxData.data);
    const subscriptionWidget = document.getElementById("juo-subscription-widget");
    const subscriptionSelect = document.querySelector(selectors2.subscriptionSelect);
    const isSubscribed = () => {
      if (!subscriptionWidget) return false;
      const checked = subscriptionWidget.querySelector(
        'input[name="mode"]:checked'
      );
      return checked && checked.value === "subscription";
    };
    const products = createProducts(boxData.data);
    const tiers = createTiers(boxData.data.tiers, boxData.data);
    const sellingPlans = createSellingPlans(
      boxData.data,
      products.data,
      isSubscribed,
      subscriptionSelect
    );

    const noCommonPlans = sellingPlans.noPlansForDedicatedGroup || sellingPlans.noCommonPlans || !sellingPlans.availablePlans || sellingPlans.availablePlans.length === 0;
    if (subscriptionWidget) {
      const jBadge = subscriptionWidget.querySelector(".j-badge");
      const jSubscription = subscriptionWidget.querySelector(".j-subscription");
      const jSubscriptionDetails = subscriptionWidget.querySelector(".j-subscription-details");
      const widgetTitle = subscriptionWidget.querySelector('[data-ref="widget-title"]');
      if (noCommonPlans) {
        subscriptionWidget.style.display = "none";
        const otpInput = subscriptionWidget.querySelector('input[name="mode"][value="otp"]');
        if (otpInput) otpInput.checked = true;
        subscriptionWidget.dataset.mode = "otp";
      } else {
        subscriptionWidget.style.display = "";
        if (jBadge) jBadge.style.display = "";
        if (jSubscription) jSubscription.style.display = "";
        if (jSubscriptionDetails) jSubscriptionDetails.style.display = "";
        if (widgetTitle) widgetTitle.style.display = "";
      }
    }

    const boxCart = createBoxCart(
      boxData.data,
      products.data,
      tiers,
      sellingPlans
    );
    window.juoBoxCart = boxCart;

    const MIN_BOX_LINE_ITEMS = Math.max(1, Number(boxData.data.minItemsCount) || 1);

    const productForm = document.querySelector(
      "form.product-form, form.product-single__form, form[data-type='add-to-cart-form']"
    );
    let sellingPlanInput =
      productForm && productForm.querySelector('input[name="selling_plan"]');
    if (productForm && !sellingPlanInput) {
      sellingPlanInput = document.createElement("input");
      sellingPlanInput.type = "hidden";
      sellingPlanInput.name = "selling_plan";
      productForm.appendChild(sellingPlanInput);
    }

    function syncSellingPlanInput() {
      if (!sellingPlanInput) return;
      if (isSubscribed() && subscriptionSelect && subscriptionSelect.value) {
        sellingPlanInput.value = subscriptionSelect.value;
      } else {
        sellingPlanInput.value = "";
      }
    }

    if (subscriptionSelect != null) {
      if (sellingPlans.availablePlans && sellingPlans.availablePlans.length > 0) {
        subscriptionSelect.innerHTML = "";
        subscriptionSelect.dataset.juoPopulated = "true";
        sellingPlans.availablePlans.forEach((plan, index) => {
          const option = document.createElement("option");
          option.value = plan.id;
          if (plan.discountValue != null) {
            option.dataset.discountValue = plan.discountValue;
          }
          if (plan.discountType != null) {
            option.dataset.discountType = plan.discountType;
          }
          option.dataset.planLabel = plan.name;
          option.textContent = `${plan.name}`;
          if (index === 0) {
            option.selected = true;
          }
          subscriptionSelect.append(option);
        });

        syncSellingPlanInput();

        subscriptionSelect.addEventListener("change", () => {
          syncSellingPlanInput();
          boxCart.dispatchBoxUpdatedEvent();
        });
        subscriptionSelect.dispatchEvent(
          new Event("change", { bubbles: true })
        );
      }
    }

    if (subscriptionWidget) {
      subscriptionWidget.addEventListener("change", (event) => {
        if (!event.target) return;
        if (
          event.target.name === "mode" ||
          event.target.matches('[data-ref="selling-plan"]')
        ) {
          syncSellingPlanInput();
          boxCart.dispatchBoxUpdatedEvent();
          if (event.target.matches('[data-ref="selling-plan"]')) {
            updateWidgetPrice();
          }
        }
      });
    }

    const form = document.querySelector(selectors2.builderForm);
    if (form == null) {
      return;
    }

    form.addEventListener("click", onClick);
    form.querySelectorAll(selectors2.qtyInput).forEach((input) => {
      input.addEventListener("change", (e) => {
        if (e != null) {
          const qtyInput = e.target;
          const variantId = qtyInput.dataset.variant ?? "";
          const totalVariantQty = boxCart.totalQtyForVariant(variantId) ?? 0;
          const newValue = qtyInput.value === "" ? "0" : qtyInput.value;
          const change = Number.parseInt(newValue, 10) - totalVariantQty;
          if (change !== 0) {
            for (let i = 0; i < Math.abs(change); i++) {
              change > 0 ? boxCart.addProduct(variantId) : boxCart.removeProduct(variantId);
            }
          }
        }
      });
    });
    document.addEventListener("click", (e) => {
      if (e == null) {
        return;
      }
      const buttonRemove = (e == null ? void 0 : e.target).matches(
        selectors2.removeBtn
      )
        ? e.target
        : null;
      if (buttonRemove != null) {
        e.stopPropagation();
        e.stopImmediatePropagation();
        const variantId = buttonRemove.dataset.variantId;
        if (variantId != null && variantId !== "") {
          boxCart.removeProduct(variantId);
        }
      }
    });

    if (productForm) {
      const formId = productForm.getAttribute("id");
      const qtyInput =
        productForm.querySelector('input[name="quantity"]') ||
        (formId
          ? document.querySelector(`input[name="quantity"][form="${formId}"]`)
          : null) ||
        document.querySelector('input[name="quantity"][data-quantity-input]');
      if (qtyInput) {
        qtyInput.addEventListener("change", () => {
          updateWidgetPrice();
        });
      }
    }

    if (productForm) {
      productForm.addEventListener("submit", async (event) => {
        let totalQty = 0;
        const qtyInputs = form.querySelectorAll('input[name^="qty["]');
        qtyInputs.forEach((input) => {
          totalQty += Number.parseInt(input.value || "0", 10);
        });

        const meetsMin = totalQty >= MIN_BOX_LINE_ITEMS;

        event.preventDefault();
        event.stopImmediatePropagation();

        if (!meetsMin) {
          const bodyElement = document.querySelector("body-element");
          if (bodyElement && bodyElement.showNotification) {
            bodyElement.showNotification(
              `Adiciona no mínimo ${MIN_BOX_LINE_ITEMS} produtos ao conjunto.`,
              "warning"
            );
          }
          return;
        }

        const submitButton = productForm.querySelector('button[type="submit"]');
        if (submitButton) {
          submitButton.setAttribute("disabled", "disabled");
          submitButton.classList.add("btn--loading");
        }

        syncSellingPlanInput();
        try {
          await boxCart.addToCart();
          qtyInputs.forEach((input) => {
            input.value = "0";
          });
          boxCart.dispatchBoxUpdatedEvent();
        } catch (error) {
          const bodyElement = document.querySelector("body-element");
          if (bodyElement && bodyElement.showNotification) {
            bodyElement.showNotification(
              error && error.message
                ? error.message
                : "Impossible d'ajouter le coffret au panier. Veuillez réessayer.",
              "warning"
            );
          }
        } finally {
          if (submitButton) {
            submitButton.removeAttribute("disabled");
            submitButton.classList.remove("btn--loading");
          }
        }
      }, true);
    }

    let juoCartPriceTimer = null;
    const scheduleWidgetPriceAfterCart = () => {
      clearTimeout(juoCartPriceTimer);
      juoCartPriceTimer = setTimeout(() => {
        updateWidgetPrice();
      }, 250);
    };
    document.addEventListener("reload-side-cart", scheduleWidgetPriceAfterCart);
    document.addEventListener("juo-box:cart:added", scheduleWidgetPriceAfterCart);

    if (window.innerWidth < 768) {
      document.addEventListener("scroll", () => {
        const drawer = document.querySelector(selectors2.drawer);
        if (window.scrollY > 10) {
          drawer == null ? void 0 : drawer.classList.add("mobile-visible");
        } else {
          drawer == null ? void 0 : drawer.classList.remove("mobile-visible");
        }
      });
    }
    document.addEventListener("juo-box:updated:state", (e) => {
      updateView(e.detail);
    });

    function updateView(subtotalData) {
      const IN_CART_CLASS = "in-cart";
      const boxProducts = boxCart.products();
      document.querySelectorAll(selectors2.productItem).forEach((productEl) => {
        const elVariantId = productEl.dataset.variantId;
        if (elVariantId == null) {
          return;
        }
        const inCart = boxProducts.some(
          (product) => product.variantId === elVariantId
        );
        if (inCart) {
          productEl.classList.add(IN_CART_CLASS);
        } else {
          productEl.classList.remove(IN_CART_CLASS);
        }
        const totalVariantQty = boxCart.totalQtyForVariant(elVariantId) ?? 0;
        const qtyInput = productEl.querySelector(
          `[name="qty[${elVariantId}]"]`
        );
        if (qtyInput != null) {
          qtyInput.value = String(totalVariantQty);
        }
        if (totalVariantQty > 0) {
          const decreaseQtyBtn = productEl.querySelector(
            `[data-qty-target="qty[${elVariantId}]"][data-qty-add="-1"]`
          );
          decreaseQtyBtn.disabled = false;
        }
        if (totalVariantQty === 0) {
          const decreaseQtyBtn = productEl.querySelector(
            `[data-qty-target="qty[${elVariantId}]"][data-qty-add="-1"]`
          );
          decreaseQtyBtn.disabled = true;
        }
      });
      const checkoutBtn = document.querySelector(selectors2.checkoutBtn);
      const stickyBtn = document.querySelector("#sticky-atc-button");
      const atcMainBtn =
        productForm && productForm.querySelector('button[type="submit"]');
      const buttons = [checkoutBtn, stickyBtn, atcMainBtn].filter(Boolean);

      if (boxData != null) {
        buttons.forEach((btn) => {
          if (boxProducts.length >= MIN_BOX_LINE_ITEMS) {
            btn.disabled = false;
            btn.classList.remove("disabled");
          } else {
            btn.disabled = true;
            btn.classList.add("disabled");
          }
        });
      }
      if (checkoutBtn != null) {
        checkoutBtn.addEventListener("click", async (e) => {
          e.stopPropagation();
          e.stopImmediatePropagation();
          checkoutBtn.disabled = true;
          checkoutBtn.classList.add("btn--loading");
          try {
            const result = await boxCart.addToCart();
            form.querySelectorAll('input[name^="qty["]').forEach((input) => {
              input.value = "0";
            });
            boxCart.dispatchBoxUpdatedEvent();
            const cartDrawer = document.querySelector("cart-drawer");
            if (cartDrawer) {
              if (result && result.sections) {
                cartDrawer.classList.remove("is-empty");
                cartDrawer.renderContents(result);
              } else {
                const cartIcon = document.querySelector("#cart-icon-bubble");
                if (cartIcon) cartIcon.click();
              }
            }
          } catch (err) {
            const bodyElement = document.querySelector("body-element");
            if (bodyElement && bodyElement.showNotification) {
              bodyElement.showNotification(
                err && err.message ? err.message : "Impossible d'ajouter au panier. Veuillez réessayer.",
                "warning"
              );
            }
          } finally {
            checkoutBtn.disabled = false;
            checkoutBtn.classList.remove("btn--loading");
          }
        });
      }
      populateProgressBar(boxCart.products());
      renderProgressBar(form, boxData.data, tiers.tiersMaxProducts);
      updateDrawerMessage(tiers, boxCart.products(), boxData.data.boxDiscountType, boxData.data);
      updateProgressBar(form, boxData.data, tiers.tiersMaxProducts);
      updateSummaryPrice(subtotalData);
      updateWidgetPrice();
    }

    function updateSummaryPrice(subtotalData) {
      const { subtotal, compareToPrice } = subtotalData;
      const totalPriceEl = document.querySelector(selectors2.totalPrice);
      const comparePriceEl = document.querySelector(selectors2.comparePrice);
      const savingsAmountEl = document.querySelector(selectors2.savingsAmount);
      const boxBuilderEl = document.querySelector(".box-builder");
      if (boxBuilderEl && boxCart && sellingPlans) {
        const forcedPlanId =
          typeof sellingPlans.getSelectedPlanId === "function"
            ? sellingPlans.getSelectedPlanId()
            : null;
        const widgetSubscribed =
          document.querySelector(
            '#juo-subscription-widget input[name="mode"]:checked'
          )?.value === "subscription";
        const subTotals = boxCart.getSubtotal({
          forceSubscribed: widgetSubscribed,
          forceSellingPlanId: widgetSubscribed ? forcedPlanId : null,
        });
        const bundleMult = getParentProductQuantityMultiplier();
        boxBuilderEl.dataset.boxSubtotal = String(
          Math.round(subTotals.subtotal * bundleMult)
        );
        boxBuilderEl.dataset.boxCompare = String(
          Math.round(subTotals.compareToPrice * bundleMult)
        );
      }
      if (comparePriceEl != null) {
        if (compareToPrice === 0 || compareToPrice === subtotal) {
          comparePriceEl.classList.add("hidden");
        } else {
          comparePriceEl.classList.remove("hidden");
        }
        comparePriceEl.textContent = formatCurrency(compareToPrice / 100);
      }
      if (totalPriceEl != null) {
        totalPriceEl.textContent = formatCurrency(subtotal / 100);
      }
      if (savingsAmountEl != null) {
        const savings = compareToPrice - subtotal;
        if (savings === 0) {
          savingsAmountEl.classList.add("hidden");
        } else {
          savingsAmountEl.classList.remove("hidden");
        }
        savingsAmountEl.textContent = formatCurrency(savings / 100);
      }
    }
    function getInputByButton(btn) {
      return form.querySelector(`input[name="${btn.dataset.qtyTarget}"]`);
    }
    function onClick(e) {
      if (e.target.matches(selectors2.changeQty)) {
        const input = getInputByButton(e.target);
        const variantId = e.target.dataset.qtyTarget.replace(
          /(qty\[)(\d+)\]/,
          "$2"
        );
        if (input.value == "") {
          input.value = "0";
        }
        const change = Number.parseInt(
          e.target.getAttribute("data-qty-add"),
          10
        );
        if (change > 0) {
          boxCart.addProduct(variantId);
        } else {
          boxCart.removeProduct(variantId);
        }
      }
      if (e.target.matches(selectors2.addToBox)) {
        e.preventDefault();
        const variantId = e.target.dataset.variantId;
        boxCart.addProduct(variantId);
      }
    }

    boxCart.dispatchBoxUpdatedEvent();
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initBuilder);
  } else {
    initBuilder();
  }
})();

document.addEventListener("DOMContentLoaded", function () {
  const variantRadios = document.querySelectorAll(
    'input[name="juo_extra_variant"]'
  );
  const priceBox = document.getElementById("juo-extra-product-price");
  const extraCheckbox = document.querySelector(".juo-extra-product__checkbox");

  if (variantRadios && priceBox) {
    variantRadios.forEach(function (radio) {
      radio.addEventListener("change", function () {
        priceBox.textContent = this.getAttribute("data-price");
        dispatchUpdate();
      });
    });
  }
  if (extraCheckbox) {
    extraCheckbox.addEventListener("change", function () {
      const selectedVariant = document.querySelector(
        'input[name="juo_extra_variant"]:checked'
      );
      const priceBox = document.getElementById("juo-extra-product-price");
      if (selectedVariant && priceBox) {
        priceBox.textContent = selectedVariant.getAttribute("data-price");
      }
      dispatchUpdate();
      updateWidgetPrice();
    });
  }
  updateWidgetPrice();
});
